<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">Folio PP - {{planProtection.folio}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div [ngClass]="{ 'dialog-container': section !== 'historial', 'dialog-container-historial': section === 'historial'}">
    <form [formGroup]="planProtectionForm">
        <div class="col-12 mb-2">
            <div id="gallery" class="gallery row">
                <div class="gallery-group-1" *ngIf="section === 'general'">

                    <div class="accordion" id="accordion">
                        <div class="accordion-item border-0">
                            <div class="accordion-header" id="headingOne">
                            <button class="accordion-button px-3 py-10px pointer-cursor" 
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                <i class="fa-solid fa-address-card fa-fw text-blue me-2 fs-16px"></i>
                                <span class="fs-16px">Datos Cliente</span>
                            </button>
                            </div>
                            <div id="collapseOne" class="accordion-collapse collapse show">
                                <div class="accordion-body bg-white">
                                    <div class="mb-2 row">
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Nombre</span>
                                            <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.nombreCliente}" formControlName="nombreCliente" type="text" />
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Celular</span>
                                            <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.celularCliente}" formControlName="celularCliente" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Correo</span>
                                            <input class="form-control" placeholder="Ingresa el correo eléctronico" formControlName="correoCliente" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <button class="btn btn-primary mt-3 w-100" (click)="getImagen('img_ine')">
                                                Ver ID
                                            </button>
                                        </div>
                                        <br>
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item border-0">
                            <div class="accordion-header" id="headingOne">
                            <button class="accordion-button px-3 py-10px pointer-cursor" 
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseCar">
                                <i class="fa-solid fa-car-side fa-fw text-blue me-2 fs-16px"></i>
                                <span class="fs-16px">Datos del Vehículo</span>
                            </button>
                            </div>
                            <div id="collapseCar" class="accordion-collapse collapse show">
                                <div class="accordion-body bg-white">
                                    <div class="row mb-2">
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Marca</span>
                                            <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.apellidosCliente}" formControlName="marca" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Modelo</span>
                                            <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.noCliente}" formControlName="modelo" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Año</span>
                                            <input class="form-control" placeholder="Ingresa el correo eléctronico" formControlName="ano" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Kilometraje</span>
                                            <div class="d-flex flex-row align-items-center justify-content-between">
                                                <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.apellidosCliente}" formControlName="kilometraje" type="text"/>
                                                <button  class="btn btn-primary" (click)="getImagen('img_tacometro')">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Placas</span>
                                            <div class="d-flex flex-row align-items-center justify-content-between">
                                                <input class="form-control" [ngClass]="{ 'is-invalid': errorsModel.noCliente}" formControlName="placas" type="text"/>
                                                <button class="btn btn-primary" (click)="getImagen('img_placas')">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">No. Serie</span>
                                            <div class="d-flex flex-row align-items-center justify-content-between">
                                                <input class="form-control" placeholder="Ingresa el correo eléctronico" formControlName="noSerie" type="text"/>
                                                <button class="btn btn-primary" (click)="getImagen('img_noSerie')">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- <div class="d-flex flex-row justify-content-between align-items-center mt-3">
                                            <button *ngIf="!isDesktop" class="btn btn-primary" (click)="getImagen('img_tacometro')">
                                                Ver Tacómetro
                                            </button>
                                             <button *ngIf="!isDesktop" class="btn btn-primary" (click)="getImagen('img_placas')">
                                                Ver Placas
                                            </button>
                                             <button *ngIf="!isDesktop" class="btn btn-primary " (click)="getImagen('img_noSerie')">
                                                Ver No. Serie
                                            </button>
                                        </div> -->
                                        <br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item border-0">
                            <div class="accordion-header" id="headingOne">
                            <button class="accordion-button px-3 py-10px pointer-cursor" 
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapsePP">
                                <i class="fa-solid fa-shield fa-fw text-blue me-2 fs-16px"></i>
                                <span class="fs-16px">Datos del Programa de Protección</span> 
                            </button>
                            </div>
                            <div id="collapsePP" class="accordion-collapse collapse show">
                                <div class="accordion-body bg-white">
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Sucursal</span>
                                            <input class="form-control"  formControlName="sucursal" type="text"/>
                                        </div>

                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Orden Venta</span>
                                            <input class="form-control" formControlName="ordenVenta" type="text" />
                                        </div>
                                                
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Sku</span>
                                            <input class="form-control"  formControlName="sku" type="text"/>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Descripción</span>
                                            <input class="form-control" formControlName="descripcion" type="text" />
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Fecha Contratado</span>
                                            <input class="form-control" formControlName="fechaContratado" type="text" />
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <span class="fs-14px font-weight-bold">Fecha Expiración</span>
                                            <input class="form-control" formControlName="fechaVigencia" type="text" disabled/>
                                        </div>
                                        <div class="d-flex flex-row justify-content-evenly align-items-center mt-2">
                                            <button (click)="abrirContrato()" class="btn btn-primary w-100 mt-2">Ver Contrato</button>
                                        </div>    
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>

                        <div class="accordion-item border-0">
                            <div class="accordion-header" id="headingOne">
                            <button class="accordion-button px-3 py-10px pointer-cursor" 
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseRedimidos">
                                <i class="fa-solid fa-screwdriver-wrench text-blue me-2 fs-16px"></i>
                                <span class="fs-16px">Servicios Redimidos</span> 
                            </button>
                            </div>
                            <div id="collapseRedimidos" class="accordion-collapse collapse show">
                                <div class="accordion-body bg-white">
                                    <div *ngFor="let redimido of redimidos" class="d-flex flex-column justify-content-start container-redencion">
                                        <span class="fs-14px font-weight-bold">Nombre: Jesus Antonio Hernandez Castruita</span>
                                        <span class="fs-14px font-weight-bold">Fecha Redimido: 10/03/2026</span>
                                        <button (click)="abrirGarantia()" class="btn btn-primary w-100 mt-2">Ver Servicios Redimidos</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </div>
                <!-- <div class="gallery-group-2" *ngIf="section === 'general'">
                    <app-servicios-pp></app-servicios-pp>
                </div> -->
                <div class="gallery-group-3 padding-0px" *ngIf="section === 'servicios' && ppVigente">
                    <!-- <p>garantia</p> -->
                    <!-- <app-garantia-pp></app-garantia-pp> -->
                    <app-carro-interactivo *ngIf="planProtectionDetail" [planPro]="planProtectionDetail"></app-carro-interactivo>
                </div>
                <div class="gallery-group-4 padding-0px" *ngIf="section === 'historial'">
                    <!-- <p>garantia</p> -->
                    <app-historial-servicios *ngIf="planProtectionDetail" [planPro]="planProtectionDetail" ></app-historial-servicios>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="bottom-menu-container">
    <div class="bottom-menu-option-container"  (click)="setOption('general')">
        <span><i class="fa-solid fa-id-card" [ngClass]="{'bottom-menu-option': !setColorSection('general'), 'bottom-menu-option-selected': setColorSection('general')}"></i></span>
        <p [ngClass]="{'bottom-menu-text': !setColorSection('general'), 'bottom-menu-text-selected': setColorSection('general')}">General</p>
    </div>
     <div *ngIf="!isDesktop && ppVigente" class="bottom-menu-option-container"  (click)="setOption('servicios')">
        <span><i class="fa-solid fa-wrench" [ngClass]="{'bottom-menu-option': !setColorSection('servicios'), 'bottom-menu-option-selected': setColorSection('servicios')}"></i></span>
        <p [ngClass]="{'bottom-menu-text': !setColorSection('servicios'), 'bottom-menu-text-selected': setColorSection('servicios')}">Servicios y Garantias</p>
    </div>
     <div class="bottom-menu-option-container"  (click)="setOption('historial')">
        <span><i class="fa-solid fa-clock" [ngClass]="{'bottom-menu-option': !setColorSection('historial'), 'bottom-menu-option-selected': setColorSection('historial')}"></i></span>
        <p [ngClass]="{'bottom-menu-text': !setColorSection('historial'), 'bottom-menu-text-selected': setColorSection('historial')}">Historial</p>
    </div>
</div>